import { api } from './client'

export interface InviteInfo {
  inviter_username: string
}

export function sendInvite(email: string): Promise<{ message: string }> {
  return api.post<{ message: string }>('/invites', { email })
}

export function getInviteInfo(token: string): Promise<InviteInfo> {
  return api.get<InviteInfo>(`/invites/${token}`)
}

export function claimInvite(token: string): Promise<{ message: string }> {
  return api.post<{ message: string }>(`/invites/${token}/claim`)
}
